module.exports = global["Parse"] = require("-!./papaparse.min.js");